/* eslint-disable max-lines */
import React, { ReactNode, SVGProps } from 'react'

export const TimerSizeMSvg = ({
  counter,
  ...restProps
}: SVGProps<SVGSVGElement> & { counter?: ReactNode }) => (
  <svg
    width="250"
    height="135"
    viewBox="0 0 250 135"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <text
      x={100}
      y={116}
      fill="#2E3D49"
      style={{
        fontFamily: 'Arial',
        fontSize: 16,
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: 'normal',
      }}
    >
      {counter}
    </text>
  </svg>
)
